import EzController from 'controllers/ez-base-controller';
import { sendTrackingEvent, TrackingEvent, TrackingData } from 'components/analytics/conversions/tracking';

export default class TrackTriggerEventController extends EzController {
  // #region Types
  /* eslint-disable lines-between-class-members */
  declare actionValue:string;
  declare readonly hasActionValue:boolean;

  declare labelValue:string;
  declare readonly hasLabelValue:boolean;

  declare valueValue:string;
  declare readonly hasValueValue:boolean;

  declare sendFromBodyValue:boolean;

  declare includeDataValue:string;
  declare readonly hasIncludeDataValue:boolean;
  /* eslint-enable lines-between-class-members */
  // #endregion

  static values = {
    action: String,
    label: String,
    value: String,
    includeData: String,
    sendFromBody: { type: Boolean, default: false },
  };

  connect() {
    if (!this.hasActionValue) return;

    const payload:TrackingData = {
      action: this.actionValue,
    };

    if (this.hasLabelValue) payload.label = this.labelValue;
    if (this.hasValueValue) payload.value = this.valueValue;

    Object.assign(payload, this.processIncludedData());

    const trackedEvent:TrackingEvent = { data: payload };
    if (this.sendFromBodyValue !== true) {
      trackedEvent.element = this.element as HTMLElement;
    }

    sendTrackingEvent(trackedEvent);
  }

  processIncludedData() {
    if (!this.hasIncludeDataValue) return {};

    const data = {};
    const values = this.includeDataValue.split(',').map((i) => i.trim());

    values.forEach((value) => {
      data[value] = (this.element as HTMLElement).dataset[value];
    });

    return data;
  }
}
